import React from 'react';
import { Navigate, Params } from 'react-router-dom';
import { inject, observer } from 'mobx-react';   
import { UtilityMethods, withRouter } from '@mindmemobile/mm-shared-global';
import { DonationStore } from '../../../shared/store';
import { UpsertDonationActiveStep } from '../../../shared/enums';

interface IProps {
    donationStore?: DonationStore;
    children: React.ReactElement;
    currentRoute: string;
    params: Readonly<Params<string>>;
}

const ProtectedRoute: React.FC<IProps> = ({ children, currentRoute, donationStore, params }) => {
    let isValid = false;
    const donationId = () => {
        const split = ((params && params['*']) || '').split('/');
        const id = split[split.length - 1];
        if (UtilityMethods.isValidObjectId(id)) {
            return id;
        }
        return null;
    };

    switch (donationStore?.activeStep) {
        case UpsertDonationActiveStep.Detail:
            isValid = currentRoute === 'detail';
            break;
        case UpsertDonationActiveStep.Pricing:
            isValid = currentRoute === 'pricing';
            break;
        case UpsertDonationActiveStep.Options:
            isValid = currentRoute === 'options';
            break;
    }

    const queryParam: string = donationId() ? `/${donationId()}` : '';
    return isValid ? children : <Navigate to={`/app/donation/detail${queryParam}`} />;
};

export default inject('donationStore')(withRouter(observer(ProtectedRoute)));
